<script>
	import { onMount } from 'svelte';
	import { toast_message } from '../../utils/toast_message.js';
    import { querystring } from 'svelte-spa-router';

	
	onMount(async () => {
		const params = new URLSearchParams($querystring);
		const auth_type = params.get('auth_type');
		const auth_token = params.get('auth_token');
		const domain_code = params.get('domain_code');
		if (auth_type && auth_token && domain_code) {
			localStorage.setItem('HoyToKenTy', auth_type);
            localStorage.setItem('HoyToKenTo', auth_token);
			localStorage.setItem('HoyDoMainCode', domain_code);
            window.location.href = '/';
		} else {
			toast_message(false, 'Invalid request', 3000);
		}
	});
</script>

<div style="width: 100%;height: 100%;text-align: center;margin-top: 30px;">
	<h1>Redirecting...</h1>
</div>